

import __layout_0 from '/opt/deploy/tapon-pc/tapon-pc/src/layouts/default.vue'
export const layouts = {
'404': () => import('/opt/deploy/tapon-pc/tapon-pc/src/layouts/404.vue'),
'default': __layout_0,
'other': () => import('/opt/deploy/tapon-pc/tapon-pc/src/layouts/other.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      component: layouts[route.meta?.layout || 'default'],
      children: [ {...route, path: ''} ],
    }
  })
}
